import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import Actions from './actions';
var Types = Actions.Types;
var INITIAL_STATE = {
  secondaryNavVisible: false,
  accountNavVisible: false
};

var headerReducer = function headerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case Types.TOGGLE_SIDENAV:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          secondaryNavVisible: !state.secondaryNavVisible,
          waitlistActive: false,
          accountNavVisible: false
        });
      }

    case Types.TOGGLE_ACCOUNTNAV:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          accountNavVisible: !state.accountNavVisible,
          waitlistActive: false,
          secondaryNavVisible: false
        });
      }

    default:
      {
        return state;
      }
  }
};

export default headerReducer;